import { useMemo } from 'react';
import * as R from 'remeda';
import { getIDFromUrl } from '@rossum/api-client';
import { useFieldManagerDataContext } from '../../hooks/FieldManagerDataContext';
import { Queue } from '../../types/queue';

export const useWorkspacesWithQueues = () => {
  const { queues, workspaces, isLoading } = useFieldManagerDataContext();

  const queueObject = useMemo(() => {
    return queues?.reduce<Record<number, Queue>>((acc, queue) => {
      return {
        ...acc,
        [queue.id]: queue,
      };
    }, {});
  }, [queues]);

  const allWorkspacesWithQueues = useMemo(
    () =>
      workspaces
        ?.map(workspace => {
          const { queues: workspaceQueues, metadata, ...rest } = workspace;
          const queuesOfWorkspace = R.pipe(
            workspaceQueues?.map(queueUrl => {
              const queueId = getIDFromUrl(queueUrl);
              return queueObject?.[queueId] || undefined;
            }),
            R.filter(R.isTruthy)
          );

          return {
            ...rest,
            queues: queuesOfWorkspace,
          };
        })
        ?.sort((a, b) => a.name.localeCompare(b.name)),

    [queueObject, workspaces]
  );

  const workspacesWithQueues = useMemo(() => {
    return allWorkspacesWithQueues?.filter(
      workspace => workspace.queues.length && workspace.queues[0]
    );
  }, [allWorkspacesWithQueues]);

  return {
    workspacesWithQueues,
    allWorkspacesWithQueues,
    queues,
    isLoading,
  };
};
